import React from 'react';
import CaseList from './CaseList';
import { APP_TERMS } from '../../app-terms';
import { CASE_STATUS_SUBMITTED } from './CaseConstants';
import PropTypes from 'prop-types';
const BREAD_CRUMBS = [
  { label: 'Case', to: '/user/case/submitted' },
  { label: 'Submitted', to: '/user/case/submitted' },
];
const SubmittedCases = () => {
  
  return (
    <div>
      <div>
        <CaseList
          title={APP_TERMS.submitted_case_list_title}
          caseStatus={CASE_STATUS_SUBMITTED}
          breadCrumbItems={BREAD_CRUMBS}
          showHasFilter = {true}
          showProStatusFilter = {true}
        />
      </div>
    </div>
  );
};

CaseList.propTypes = {
  title: PropTypes.string.isRequired,
  caseStatus: PropTypes.string.isRequired,
  breadCrumbItems: PropTypes.array,
  showHasFilter: PropTypes.bool,
  showProStatusFilter: PropTypes.bool,
  
};

export default SubmittedCases;
